<script>
import {
    Block,
    BlockTitle,
    Link,
    Tabs,
    Tab
} from 'framework7-svelte';
import { onMount } from 'svelte';
onMount(() => {

})
</script>
<style>
    table {
        border: none;
        width: 100%;
        border-collapse: collapse;
    }
    td {
        padding: 5px 10px;
        text-align: center;
        border: 1px solid #999;
    }
    th {
        padding: 5px 10px;
        text-align: center;
        border: 1px solid #999;
    }
</style>

<BlockTitle>Imágenes de satélite y cartografía utilizada en el sistema de alerta temprana de incendios forestales (SATIF)</BlockTitle>
<Block>
    <p>Comisión Nacional para el Conocimiento y Uso de la Biodiversidad (CONABIO)</p>
    <strong>Contenido</strong>
</Block>
<Block strong inset>
    <ol>
        <li>
            <p><Link tabLink="#tab-4-1" tabLinkActive>Imágenes de satélite</Link></p>
        </li>
        <li><p><Link tabLink="#tab-4-2">Cartografía</Link></p></li>
        <li><p><Link tabLink="#tab-4-3">Forma de citar este documento</Link></p></li>
    </ol>
</Block>
<Tabs>
    <Tab id="tab-4-1" tabActive>
        <BlockTitle >1. IMÁGENES DE SATÉLITE</BlockTitle>
        <Block strong mediumInset style="text-align: justify;">
            <p><strong>a) Características</strong></p>
            <p>
                Las imágenes satelitales utilizadas en el SATIF para los puntos de calor forman parte de los programas de Observación de la Tierra a cargo de la NASA (National Aeronautics and Space Administration)
                el Sistema de Observación de la Tierra y de la NOAA (National Oceanic and Atmospheric Administration) el Sistema de Observación.
            </p>
            <p>
                Las imágenes que se reciben actualmente en el sistema de recepción de la CONABIO son:
                MODIS<a href="#_ftn1" name="_ftnref1" title=""><span style="vertical-align:super;"><span style="vertical-align:super;"><span style='font-size:15px;line-height:107%;font-family:"Calibri",sans-serif;'>[1]</span></span></span></a> 
                (Moderate Resolution Imaginen Spectroradiometer) provenientes de los satélites Terra y Aqua,
                imágenes VIIRS (Visible Infrared Imaging Radiometer) de los satélites Suomi-NPP y JPSS/NOAA20.
            <p>
                En la tabla 1 se presentan las principales características de las imágenes que se han utilizado en la detección de
                incendios forestales en México por la Comisión Nacional para el Conocimiento y Uso de la Biodiversidad (CONABIO).
            </p>
            <p>
                El área captada por una imagen satelital depende de muchos factores, entre ellos: el swath (franja de observación) y la
                posición del satélite (altura respecto al horizonte y orientación) cuando pasa sobre la antena que recibe la señal.
                Por lo tanto, no siempre se observa todo el territorio en una sola imagen.
                La figura 1 presenta el área cubierta por cada una de las imágenes recibidas el día 8 de febrero de 2021 en el sistema de
                recepción de la CONABIO (México). Mientras la figura 2 presenta la distribución de dichas imágenes a lo largo del día.
                Los colores de las barras indican el sensor y la altura el porcentaje de cobertura.
            </p>
            <p style='margin:0cm;font-size:13px;font-family:"Calibri",sans-serif;'><a href="#_ftnref1" name="_ftn1" title=""><span style="vertical-align:super;"><span style="vertical-align:super;"><span style='font-size:13px;line-height:107%;font-family:"Calibri",sans-serif;'>[1]</span></span></span></a> Las im&aacute;genes MODIS se encuentran disponibles en la p&aacute;gina web de la CONABIO desde 2004.</p>
            <br>
            <table style="border: none;width:446.05pt;border-collapse:collapse;">
                <caption>Tabla 1. Características principales de los datos satelitales para detectar incendios forestales en el SATIF</caption>
                <tr>
                    <th scope="col" >Satélites</th>
                    <th >F14</th>
                    <th >NOAA 12 <br>
                        NOAA 14
                    </th>
                    <th >TERRA Y AQUA</th>
                    <th colspan="2">S-NPP Y JPSS</th>
                </tr>
                <tr>
                    <th >Sensores</th>
                    <td >DMSP-OLS</td>
                    <td >AVHRR</td>
                    <td >MODIS</td>
                    <td colspan="2">VIIRS</td>
                </tr>
                <tr>
                    <th >Años de uso en el SATIF</th>
                    <td >1998</td>
                    <td >1999 - 2003</td>
                    <td >2004 - </td>
                    <td colspan="2">2014 - </td>
                </tr>
                <tr>
                    <th >Resolución espectral<br>
                        (Número de bandas)
                    </th>
                    <td >2</td>
                    <td >5</td>
                    <td >36</td>
                    <td colspan="2">2</td>
                </tr>
                <tr>
                    <th >Resolución espacial</th>
                    <td >Fina 580 m<br> Suavizadas 2500 m</td>
                    <td >1100 m</td>
                    <td >250 m, 500 m y 1000 m</td>
                    <td colspan="2">375 m<br>750 m</td>
                </tr>
                <tr>
                    <th >Imágenes del día</th>
                    <td >1</td>
                    <td >2</td>
                    <td >de 4 a 8</td>
                    <td colspan="2">de 4 a 8</td>
                </tr>
                <tr>
                    <th >Franja de observación<br>(Swath)</th>
                    <td >Fina 580 m<br> Suavizadas 2500 m</td>
                    <td >1100 m</td>
                    <td >250 m, 500 m y 1000 m</td>
                    <td colspan="2">375 m<br>750 m</td>
                </tr>
                <tr>
                    <td colspan="6" >Características de las bandas para la detección de puntos de calor</td>
                </tr>
                <tr>
                    <th >Resolución espacial</th>
                    <td >  </td>
                    <td > </td>
                    <td > </td>
                    <td > </td>
                    <td > </td>
                </tr>
                <tr>
                    <th >Banda visible - infrarrojo</th>
                    <td >0.58 - 0.91 µm</td>
                    <td > </td>
                    <td > </td>
                    <td > </td>
                    <td > </td>
                </tr>
                <tr>
                    <th >Banda infrarrojo medio</th>
                    <td > </td>
                    <td >1100 m </td>
                    <td >1000 m </td>
                    <td >750 m </td>
                    <td >375 m </td>
                </tr>
                <tr>
                    <th >Banda infrarrojo térmico</th>
                    <td > </td>
                    <td >1100 m </td>
                    <td >1000 m </td>
                    <td >750 m </td>
                    <td >375 m </td>
                </tr>
                <tr>
                    <th >Banda infrarrojo medio</th>
                    <td > </td>
                    <td >Banda 3:<br> 3.55 - 3.93 µm </td>
                    <td >Banda 21:<br> 3.929 - 3.989 µm<br>Banda 22:3.929 - 3.989 µm </td>
                    <td >Banda M13:<br> 3.973 - 4.128 µm </td>
                    <td >Banda I4:<br> 3.550 - 3.930 µm </td>
                </tr>
                <tr>
                    <th >Banda infrarrojo térmico</th>
                    <td > </td>
                    <td >Banda 4:<br> 10.30 - 11.30 µm </td>
                    <td >Banda 31:<br> 10.780 - 11.280 µm</td>
                    <td >Banda M15:<br> 10.263 - 11.263 µm </td>
                    <td >Banda I5:<br> 10.50 - 12.40 µm </td>
                </tr>
                <tr>
                    <td colspan="6">Saturación en las bandas para detección de puntos de calor</td>
                </tr>
                <tr>
                    <th >Banda (3 a 5 µm)</th>
                    <td > </td>
                    <td >47° C</td>
                    <td >Banda 21: 227°C<br> Banda 22: 58°C</td>
                    <td >Banda M13: 70°C <br>ganancia alta<br>361°C ganancia baja</td>
                    <td >Banda I4:94°C</td>
                </tr>
                <tr>
                    <th >Banda (10 a 12 µm)</th>
                    <td > </td>
                    <td >47° C</td>
                    <td >127 °C</td>
                    <td >Banda M15: 90°C </td>
                    <td >Banda I5:107°C</td>
                </tr>
            </table>
            <br>
            <img src="static/jpeg/imgCarto1.jpg" width="595px;">
            <p>
                Figura 1. Ejemplo de la cubertura de cada imagen satelital recibida en el sistema de recepción para el día 8 de febrero de 2021.
            </p>
            <img src="static/jpeg/imgCarto2.jpg" width="595px;">
            <p>
                Figura 2. Distribución temporal en un día de las imágenes recibidas el 8 de febrero de 2021
            </p>
            <p><strong>b) Ejemplos</strong></p>
            <p>
                Actualmente en el SATIF se emplean las imágenes MODIS y VIIRS para la detección de puntos de calor. La figura 3 presenta un ejemplo de estas imágenes. Así como, un ejemplo de un incendio forestal visto en tres formas diferentes: A) combinación en color verdadero (como el ojo humano percibe los colores), donde destaca la columna de humo del incendio. B) Combinación en falso color, donde se utilizan bandas en el infrarrojo que permiten observa el área quemada en color café oscuro y píxeles con fuego activo en color naranja y C) píxeles con anomalía térmica en color blanco y gris claro, en este caso se utiliza una banda de infrarrojo térmico. 
            </p>
            <p>
                La figura 4 presenta la comparación entre imágenes satelitales MODIS y Sentinel-2, estas últimas del programa espacial Copernicus de la Agencia 
                Espacial Europea (ESA por sus siglas en inglés), ambas utilizadas para la identificación de áreas quemadas. Las imágenes MODIS (500 m) 
                son utilizadas para generar los mapas mensuales de áreas quemadas y el mapa de frecuencia. Las imágenes Sentinel-2, son utilizadas para identificar áreas quemadas durante el combate de los incendios, por su resolución espacial de 20 m y su disposición de cada 5 o 6 días.  Cuando no hay disponibilidad de estas imágenes se emplean las imágenes MODIS, porque se reciben diariamente.
            </p>
            <img src="static/jpeg/imgCarto3.jpg" width="595px;">
            <p>Figura 3. Observación de un incendio en una imagen de satélite MODIS</p>
            <img src="static/jpeg/imgCarto4.jpg" width="595px;">
            <p>Figura 4. Datos satelitales para la identificación de área quemadas. Ejemplo: incendio ocurrido en Sierra de Arteaga, Coahuila, México en 2021</p>
        </Block>
    </Tab>
    <Tab id="tab-4-2">
        <BlockTitle >2.	CARTOGRAFIA UTILIZADA</BlockTitle>
        <Block strong mediumInset style="text-align: justify;">
            <p>
                La cartografía temática para caracterizar el sitio, donde se detecta un punto de calor, se actualiza conforme se encuentra disponible en las diferentes instituciones que la generan. La tabla 2 presentan la cartografía usada a lo largo de los años del SATIF para México, Centroamérica y Estados Unidos.
                En azul se indica la cartografía que actualmente está en uso.
            </p>
            <table class="default">
                <tr>
                    <th>Tema</th>
                    <th>Cita</th>
                    <th>Fuente</th>
                    <th>Fecha de inicio</th>
                    <th>Fecha de término</th>
                </tr>
                <tr>
                    <td rowspan="6">División politica</td>
                    <td>Cea-Herrera, Ma. E., del Valle-Ángeles, M. A., Escamilla-Herrera, I. y Godínez-Calderón, L. (1990),"División Municipal de México, 1990", I.1.3. 
                        Atlas Nacional de México. Vol I. Escala 1:4000000. Instituto de Geografía, UNAM. México.
                    </td>
                    <td>Cea-herrera et al. (1990) División municipal</td>
                    <td>01/01/2000</td>
                    <td>31/10/2002</td>
                </tr>
                <tr>
                    <td>Instituto Nacional de Estadística Geografía e Informática (INEGI), (2002).
                        "División Municipal de México, 2000". Obtenido de Marco Geoestadístico Municipal, 2000. Escala 1:250000. México.
                    </td>
                    <td>INEGI (2000) División municipal</td>
                    <td>01/01/2003</td>
                    <td>2005</td>
                </tr>
                <tr>
                    <td>Instituto Nacional de Estadística Geografía e Informática (INEGI), (2006). "División Municipal de México, 2005". 
                        Obtenido de Marco Geoestadístico Municipal, II Conteo de Población y Vivienda 2005. Versión 1.0. Escala 1:250000. México.
                    </td>
                    <td>INEGI (2006) División municipal</td>
                    <td>2006</td>
                    <td>2011</td>
                </tr>
                <tr>
                    <td>Instituto Nacional de Estadística y Geografía - INEGI. (ed.). "Áreas Geoestadísticas Municipales, 2010". 
                        Obtenido de Marco Geoestadístico 2010 versión 5.0. Aguascalientes, Ags.
                    </td>
                    <td>INEGI</td>
                    <td>2012</td>
                    <td>2016</td>
                </tr>
                <tr>
                    <td>Instituto Nacional de Estadística y Geografía - INEGI. (ed.). "Áreas Geoestadísticas Municipales, 2015". 
                        Obtenido de Marco Geoestadístico 2015. Aguascalientes, Ags.
                    </td>
                    <td>INEGI</td>
                    <td>2017</td>
                    <td>2018</td>
                </tr>
                <tr style="color:#007aff">
                    <td>INEGI, (01/09/2019). 'División política municipal, 1:250000. 2019', escala: 1:250000. edición: 1. Instituto Nacional de Estadística y Geografía. extraído de 
                        <a target="_blank" href="https://www.inegi.org.mx/app/biblioteca/ficha.html?upc=889463674658">https://www.inegi.org.mx/app/biblioteca/ficha.html?upc=889463674658</a> Aguascalientes, México..
                    </td>
                    <td>INEGI,2019</td>
                    <td>2019</td>
                    <td>a la fecha</td>
                </tr>
                <tr>
                    <td rowspan="6">Uso de suelo y vegetación</td>
                    <td>Cea-Herrera, Ma. E., del Valle-Ángeles, M. A., Escamilla-Herrera, I. y Godínez-Calderón, L. (1990),"División Municipal de México, 1990", I.1.3. 
                        Atlas Nacional de México. Vol I. Escala 1:4000000. Instituto de Geografía, UNAM. México.
                    </td>
                    <td>Cea-herrera et al. (1990) División municipal</td>
                    <td>01/01/2000</td>
                    <td>31/10/2002</td>
                </tr>
                <tr>
                    <td>Instituto Nacional de Estadística, Geografía e Informática – Dirección General de Geografía- – INEGI (ed.). 2001. Conjunto de Datos Vectoriales de la Carta de Uso del Suelo y Vegetación, Escala 1:250,000, Serie II (CONTINUO NACIONAL). 
                        Instituto Nacional de Estadística, Geografía e Informática (INEGI). Aguascalientes, Ags., México.
                    </td>
                    <td>INEGI (2001) Uso del suelo y vegetación, Serie II</td>
                    <td>01/01/2003</td>
                    <td>31/12/2008</td>
                </tr>
                <tr>
                    <td>Instituto Nacional de Estadística, Geografía e Informática – Dirección General de Geografía – INEGI (ed.). 2005. Conjunto de Datos Vectoriales de la Carta de Uso del Suelo y Vegetación, Escala 1:250,000, Serie III (CONTINUO NACIONAL). 
                        Instituto Nacional de Estadística, Geografía e Informática (INEGI). Aguascalientes, Ags., México.
                    </td>
                    <td>INEGI (2005) Uso del suelo y vegetación. Serie III</td>
                    <td>2009</td>
                    <td>2012</td>
                </tr>
                <tr>
                    <td>Dirección General de Geografía - INEGI (ed.). (2009). "Conjunto de datos vectoriales de la carta de uso del suelo y vegetación, escala 1:250000, serie IV (continuo nacional)". 
                        Instituto Nacional de Estadística, Geografía e Informática - INEGI. Aguascalientes, Ags., México.
                    </td>
                    <td>INEGI (2009) Uso del suelo y vegetación. Serie IV</td>
                    <td>2012</td>
                    <td>2013</td>
                </tr>
                <tr>
                    <td> INEGI, (12/12/2013). 'Conjunto de datos vectoriales de uso de suelo y vegetación escala 1:250 000, serie V (capa unión)', escala: 1:250000. edición: 2a. 
                        Instituto Nacional de Estadística y Geografía. Aguascalientes, Aguascalientes.
                    </td>
                    <td>INEGI (2013) Uso del suelo y vegetación. Serie V</td>
                    <td>2013</td>
                    <td>2018</td>
                </tr>
                <tr style="color:#007aff">
                    <td> INEGI, (16/12/2016). 'Conjunto de Datos Vectoriales de Uso de Suelo y Vegetación. Escala 1:250 000. Serie VI (Capa Unión)', escala: 1:250 000. edición: 1. 
                        Instituto Nacional de Estadística y Geografía. Aguascalientes, México.
                    </td>
                    <td>INEGI (2016) Uso del suelo y vegetación. Serie VI</td>
                    <td>2018</td>
                    <td>A la fecha</td>
                </tr>
                <tr>
                    <td rowspan="6">Áreas Naturales Protegidas</td>
                    <td>Instituto Nacional de Ecologia (1999) "Áreas Naturales Protegidas".
                        Unidad Coordinadora de Áreas Naturales Protegidas, INE-SEMARNAP
                    </td>
                    <td>CONANP (1999) ANP</td>
                    <td>01/01/2000</td>
                    <td>31/12/2007</td>
                </tr>
                <tr>
                    <td>Comisión Nacional de Áreas Naturales Protegidas (2007) "Áreas Naturales Protegidas Federales 13 de junio de 2007".
                        Morelia Mich. México
                    </td>
                    <td>CONANP (2007) ANP</td>
                    <td>01/01/2008</td>
                    <td>02/03/2009</td>
                </tr>
                <tr>
                    <td>Comisión Nacional de Áreas Naturales Protegidas (2008) "Áreas Naturales Protegidas Federales". Morelia Mich. México.
                        Mapas de zonificación y zonas núcleo de las ANP de Chiapas (2007)
                    </td>
                    <td>INEGI (2005) Uso del suelo y vegetación. Serie III</td>
                    <td>03/03/2009</td>
                    <td>2011</td>
                </tr>
                <tr>
                    <td>Comisión Nacional de Áreas Naturales Protegidas 2011. Cobertura de las Áreas Naturales Protegidas Federales de México. 
                        Morelia, Michoacán de Ocampo. México. Comisión Nacional de Áreas Naturales Protegidas.
                    </td>
                    <td> </td>
                    <td>2012</td>
                    <td>2017</td>
                </tr>
                <tr>
                    <td> Comisión Nacional de Áreas Naturales Protegidas 2017. Cobertura de las Áreas Naturales Protegidas Federales de México. 
                        México. Comisión Nacional de Áreas Naturales Protegidas.
                    </td>
                    <td>CONANP</td>
                    <td>2018</td>
                    <td>2018</td>
                </tr>
                <tr style="color:#007aff">
                    <td> Comisión Nacional de Áreas Naturales Protegidas 2019. Cobertura de las Áreas Naturales Protegidas Federales de México. México.
                        Comisión Nacional de Áreas Naturales Protegidas.
                    </td>
                    <td>CONANP</td>
                    <td>2019</td>
                    <td>A la fecha</td>
                </tr>
                <tr>
                    <td rowspan="2">Pendiente</td>
                    <td>Comisión Nacional para el Conocimiento y Uso de la Biodiversidad (2000) "Inclinación del terreno en grados". 
                        Calculadas a partir del modelo digital del terreno de 90 m, generado por el INEGI.
                    </td>
                    <td>CONABIO (2000) Pendientes</td>
                    <td>01/04/2000</td>
                    <td>2012</td>
                </tr>
                <tr style="color:#007aff">
                    <td>ASTER GDEM (junio 29, 2009). 'Modelo Digital de Elevación Global ASTER'. Producto de METI y NASA . Escala 1:50000. 
                        Procesado en CONABIO. México.
                    </td>
                    <td> Es un producto de METI y NASA </td>
                    <td>2012</td>
                    <td>A la fecha</td>
                </tr>
                <tr>
                    <th colspan="5">Centroamérica</th>
                </tr>
                <tr>
                    <td rowspan="5">División Política de Centroamérica (Límites Municipales)</td>
                    <td>ESRI (1998) Countries 98. Obtenido del programa Arcview.</td>
                    <td>ESRI (1998) División política</td>
                    <td>01/01/2004</td>
                    <td>2002</td>
                </tr>
                <tr>
                    <td>Mapa de municipios de Guatemala, proporcionado por SIPECIF</td>
                    <td> SIPECIF (2002) División municipal</td>
                    <td>15/04/2002</td>
                    <td>2011</td>
                </tr>
                <tr>
                    <td>Mapa de municipios de Costa Rica, proporcionado por el ministerio del ambiente y energía</td>
                    <td> MINAE (2002) Municipios de Costa Rica</td>
                    <td>01/04/2002</td>
                    <td>2011</td>
                </tr>
                <tr>
                    <td>Mapa de municipios de El Salvador, proporcionado por el sistema nacional de estudios territoriales</td>
                    <td> SNET (2004) Municipios de El Salvador</td>
                    <td>01/01/2004</td>
                    <td>2011</td>
                </tr>
                <tr style="color:#007aff">
                    <td>Global Administrative Areas (various years) V.1 . University of California, Berkely. 
                        [digital geospatial data]. Available online: http://www.gadm.org [dd/mm/yyyy].
                    </td>
                    <td> Estos archivos fueron extraídos de GADM (Base de datos Global de Áreas Administrativas) V 1.0 en Marzo del 2009. Ver http://gadm.org/ 
                        (http://library.mcmaster.ca/maps/geospatial/global-administrative-areas-0)
                    </td>
                    <td>2012</td>
                    <td>a la fecha</td>
                </tr>
                <tr>
                    <td rowspan="2">Vegetación</td>
                    <td>INAB-Banco Mundial (2000) Mapa de cobertura forestal de Guatemala para 1999. Escala 1:250 000</td>
                    <td>INAB-Banco Mundial (2000) Cobertura forestal de Guatemala</td>
                    <td>15/04/2002</td>
                    <td>a la fecha</td>
                </tr>
                <tr style="color:#007aff">
                    <td>Banco Mundial (2001) Mapa de ecosistemas de Centroamérica. Escala 1:250 000</td>
                    <td> Banco Mundial (2001) Ecosistemas de Centroamérica</td>
                    <td>01/01/2004</td>
                    <td>a la fecha</td>
                </tr>
                <tr>
                    <td rowspan="2">Áreas Naturales protegidas</td>
                    <td>(Vegetación de Guatemala) INAB-Banco Mundial (2000) Mapa de cobertura forestal de Guatemala para 1999. Escala 1:250 000</td>
                    <td>INAB-Banco Mundial (2000) Cobertura forestal de Guatemala</td>
                    <td>15/04/2002</td>
                    <td>2012</td>
                </tr>
                <tr style="color:#007aff">
                    <td>Comisión Centroamericana de Ambiente y Desarrollo (CCAD), Banco Mundial. (2004). "Áreas Protegidas Belice", "Áreas Protegidas Costa Rica", "Áreas Protegidas Guatemala", "Áreas Protegidas Honduras", "Áreas Protegidas Nicarágua", "Áreas Protegidas Panamá". Escala 1:250000. Ministerio del Medio Ambiente y Recursos Naturales (MARN). (1998).
                        "Sistema Nacional de Áreas Naturales Protegidas El Salvador". Escala 1:200000 . San Salvador.
                    </td>
                    <td>Unión de la información cartográfica de las Áreas Naturales Protegidas de los Países de Centroamérica</td>
                    <td>2012</td>
                    <td>a la fecha</td>
                </tr>
                <tr style="color:#007aff">
                    <td>Pendiente</td>
                    <td>ASTER GDEM (junio 29, 2009). 'Modelo Digital de Elevación Global ASTER'. 
                        Es un producto de METI y NASA. Escala 1:50000. Procesado en CONABIO. México.
                    </td>
                    <td> Es un producto de METI y NASA </td>
                    <td>2012</td>
                    <td>A la fecha</td>
                </tr>
                <tr>
                    <th colspan="5">Estados Unidos</th>
                </tr>
                <tr style="color:#007aff">
                    <td>División municipal</td>
                    <td>Global Administrative Areas (various years) V.1 . University of California, Berkely. 
                        [digital geospatial data]. Available online: http://www.gadm.org [01/01/2012].
                    </td>
                    <td>Estos archivos fueron extraídos de GADM (Base de datos Global de Áreas Administrativas) V 1.0 en Marzo del 2009. 
                        Ver http://gadm.org/ (http://library.mcmaster.ca/maps/geospatial/global-administrative-areas-0). University of California, Berkely
                    </td>
                    <td>2012</td>
                    <td>A la fecha</td>
                </tr>
                <tr style="color:#007aff">
                    <td>Cobertura de suelo</td>
                    <td>“2005 North American Land Cover at 250 m spatial resolution. Produced by Natural Resources Canada/Canadian Centre for Remote Sensing (NRCan/CCRS), United States Geological Survey (USGS); Instituto Nacional de Estadística y Geografía (INEGI), 
                        Comisión Nacional para el Conocimiento y Uso de la Biodiversidad (CONABIO) and Comisión Nacional Forestal (CONAFOR).” 
                    </td>
                    <td>USGS</td>
                    <td>2012</td>
                    <td>A la fecha</td>
                </tr>
            </table>
        </Block>
    </Tab>
    <Tab id="tab-4-3">
        <BlockTitle >3. FORMA DE CITAR ESTE DOCUMENTO</BlockTitle>
        <Block strong mediumInset style="text-align: justify;">
            <p>
                CONABIO. Comisión Nacional para el Conocimiento de la Biodiversidad. 2021.
                Imágenes de satélite y cartografía utilizada en el sistema de alerta temprana de incendios forestales (SATIF). 
                En XXXXX, última consulta [Fecha de la consulta]
            </p>
        </Block>
    </Tab>
</Tabs>
